<template>
    <div class="card-body px-0 pt-0 pb-3">
        <div class="table-responsive">
            <el-table border :data="this.data" class="el-table-css" style="width: 100%">
                <el-table-column label="Şirkətin adı" width="250">
                    <template #default="scope">
                        <a class="number-link" style="color: #007bff;" @click="GoToPolicy(scope.row.clientId)">{{
                            scope.row.companyName }}</a>
                    </template>
                </el-table-column>
                <el-table-column prop="voen" label="VOEN" width="150" />
                <el-table-column prop="phone" label="Telefon" width="140" />
                <el-table-column prop="email" label="Email" width="250" />
                <el-table-column prop="address" label="Ünvan" />
                <el-table-column prop="clientSector" label="Biznes sektoru" />
                <el-table-column prop="registrationDate" label="Qeydiyyat tarixi" width="150" />
                <el-table-column width="43">
                    <template #default="scope">
                        <el-popover style="max-width: 1000px !important;" :width="null" placement="right-start"
                            title="Info" trigger="hover" class="edit-btn">
                            <template #reference>
                                <el-button type="default" style="padding: 0 !important;" :icon="InfoFilled" text />
                            </template>
                            <template #default>
                                <div>
                                    Daxil olunub &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{ scope.row.created }} <br>
                                    Düzəliş
                                    olunub &nbsp;&nbsp;&nbsp; {{ scope.row.updated }}
                                </div>
                            </template>
                        </el-popover>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
import {
    Delete,
    Edit,
    InfoFilled
} from "@element-plus/icons-vue";

export default {
    props: {
        data: Array,
        showFilter: Boolean
    },
    data() {
        return {
            type: null,
            dialogVis: false,
            Delete,
            Edit,
            page: 1,
            object: null,
            InfoFilled,
            editing: false,
            alert: false,

        }
    },
    methods: {
        GoToQuota(value) {
            window.open(window.location.origin + '/documents/quota/' + value, "_blank");
        } 
    }
}
</script>
<style>
.diaq-row {
    --el-table-tr-bg-color: #f8caca !important;
}
</style>